import React from 'react';
import { Flex, Input, Typography } from 'antd';
import { FormikProps } from 'formik';

import { SupportProps } from '../service/support.interface';

const { Text } = Typography;

export const SupportForm = ({
    formik,
}: {
    formik: FormikProps<SupportProps>;
}) => {
    return (
        <Flex vertical gap={8}>
            <Text>
                В качестве контакта может использоваться Telegram аккаунт, бот,
                группа или канал
            </Text>
            <Input
                style={{ width: '283px' }}
                name='link'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.link}
                placeholder='https://t.me/username'
            />
        </Flex>
    );
};
